import React, { useEffect, useState, useContext } from "react";

import { Stack, Button, useDisclosure, Spinner } from "@chakra-ui/react";

import useDocumentTitle from "hooks/useDocumentTitle";

import UserDetailService from "services/UserDetailService";

import edit_icon_blue from "../../assets/images/icons/edit_icon_blue.png";
import EditProfileModal from "./EditProfileModal";
import ActiveInactiveTags from "components/Tags/ActiveInactiveTags";

import { UserDataContext } from "contexts/UserDataContext";
import ResetProfileModal from "./ResetProfileModal";

export default function Supplier() {
  useDocumentTitle("My Profile");

  const { addUserData: addUserDataContext } = useContext(UserDataContext);

  const [userData, setUserData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpenReset,
    onOpen: onOpenReset,
    onClose: onCloseReset,
  } = useDisclosure();

  const [checkUpdate, setCheckUpdate] = useState(false);

  useEffect(() => {
    const fetchUserDetail = async () => {
      setIsLoading(true);

      const response_user_data = await UserDetailService();
      setUserData(response_user_data.data.data);

      addUserDataContext(response_user_data.data.data);

      setIsLoading(false);
    };

    fetchUserDetail();
  }, [checkUpdate]);

  return (
    <div className=" ">
      <Stack spacing={"35px"}>
        <div className="  ">
          <h1 className="font-raleway  ">My Profile</h1>
        </div>
        {isLoading ? (
          <div className="flex flex-row justify-center h-[63vh]   ">
            <div className="my-auto">
              <Spinner size="xl" />
            </div>
          </div>
        ) : (
          <>
            <EditProfileModal
              isOpen={isOpen}
              onClose={onClose}
              userDataProp={userData}
              setCheckUpdate={setCheckUpdate}
            />

            <ResetProfileModal isOpen={isOpenReset} onClose={onCloseReset} />

            <div className="overflow-x-auto">
              <table className=" w-full table-auto  border primary-border-color bg-white  ">
                <thead>
                  <tr className="">
                    <th colSpan={"2"} className="px-3 pb-4   pt-6  ">
                      <div className="flex flex-row justify-between ml-2">
                        <h4>General</h4>
                        <div>
                          <Button
                            variant="ghost"
                            sx={{
                              fontSize: "1rem",
                              color: "#17bab3",
                              paddingx: "1.25rem",
                            }}
                            onClick={onOpen}
                          >
                            <div className="flex flex-row gap-2">
                              <img
                                className="h-5 w-5"
                                src={edit_icon_blue}
                                alt="edit icon blue"
                              />
                              Edit
                            </div>
                          </Button>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className=" min-h-5 border-b  border-gray-300">
                    <td className="pl-4 py-3 md:w-52  ">
                      <p className="table-heading ">Name</p>
                    </td>
                    <td className=" table-text-light  max-w-64 ">
                      <div className="whitespace-normal break-all">
                        {userData?.first_name + " " + userData?.last_name}
                      </div>
                    </td>
                  </tr>
                  <tr className="border-b h-5  border-gray-300">
                    <td className="pl-4 py-4   ">
                      <p className="table-heading ">User ID</p>
                    </td>
                    <td className=" table-text-light  max-w-64 ">
                      <div className="whitespace-normal break-all">
                        {userData?.user_id}
                      </div>
                    </td>
                  </tr>
                  <tr className="border-b  border-gray-300">
                    <td className="pl-4 py-4">
                      <p className="table-heading">Email Address</p>
                    </td>
                    <td className=" table-text-light">
                      <div className="whitespace-normal break-words">
                        {userData?.user_email}
                      </div>
                    </td>
                  </tr>
                  <tr className="border-b  border-gray-300">
                    <td className="pl-4 py-4">
                      <p className="table-heading">Password</p>
                    </td>
                    <td className=" table-text-light   ">
                      <Button
                        variant="ghost"
                        sx={{
                          fontSize: "1rem",
                          color: "#17bab3",
                          paddingx: "1.25rem",
                        }}
                        onClick={onOpenReset}
                      >
                        <div className="flex flex-row gap-2">
                          <img
                            className="h-5 w-5"
                            src={edit_icon_blue}
                            alt="edit icon blue"
                          />
                          Change Password
                        </div>
                      </Button>
                    </td>
                  </tr>
                  <tr className="border-b  border-gray-300">
                    <td className="pl-4 py-4">
                      <p className="table-heading">Activation Date</p>
                    </td>
                    <td className=" table-text-light">
                      {userData?.created_on}
                    </td>
                  </tr>
                  <tr className="border-b   border-gray-300">
                    <td className="pl-4  py-4  ">
                      <p className="table-heading">Status</p>
                    </td>
                    <td className=" py-4 table-text-light">
                      <ActiveInactiveTags
                        is_active={userData?.user_is_active}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </>
        )}

        <div className="flex flex-col"></div>
      </Stack>
    </div>
  );
}
